import { Action } from 'redux';

import { IMetricInfo } from '../models/IMetricInfo';
import { isActionFactory } from '../../app/actions/isActionFactory';

export const HideMetricsBanner = 'HideMetricsBanner';
export const ResumeMetric = 'ResumeMetric';
export const ResumeMetricFromExplorer = 'ResumeMetricFromExplorer';
export const UpdateMetricsData = 'UpdateMetricsData';
export const UpdateMetricsDataSucceeded = 'UpdateMetricsDataSucceeded';
export const AutoUpdateMetricDataStop = 'AutoUpdateMetricDataStop';
export const ReplaceMetricDataRefreshList = 'ReplaceMetricDataRefreshList';

export interface UpdateMetricsDataAction extends Action {
  type: typeof UpdateMetricsData;
  metrics: string[];
}

export function updateMetricsData(metrics: IMetricInfo[]): UpdateMetricsDataAction {
  const ids = metrics.map(m => m.id);
  return {
    type: UpdateMetricsData,
    metrics: ids
  };
}

export function updateMetricsDataByIds(ids: string[]): UpdateMetricsDataAction {
  return {
    type: UpdateMetricsData,
    metrics: ids
  };
}

export interface UpdateMetricsDataSucceededAction extends Action {
  readonly metrics: ReadonlyArray<IMetricInfo>;
}

export function updateMetricsDataSucceeded(metrics: ReadonlyArray<IMetricInfo>): UpdateMetricsDataSucceededAction {
  return {
    type: UpdateMetricsDataSucceeded,
    metrics
  };
}

export interface ResumeMetricAction extends Action {
  metric: IMetricInfo;
}

export function resumeMetric(metric: IMetricInfo): ResumeMetricAction {
  return {
    type: ResumeMetric,
    metric
  };
}

export interface ResumeMetricFromExplorerAction extends Action {
  metricId: string;
}

export function resumeMetricFromExplorer(metricId: string): ResumeMetricFromExplorerAction {
  return {
    type: ResumeMetricFromExplorer,
    metricId
  };
}

export interface HideMetricsBannerAction {}

export function hideMetricsBanner(): HideMetricsBannerAction {
  return {
    type: HideMetricsBanner,
  };
}

export function autoUpdateMetricDataStop(): Action {
  return {
    type: AutoUpdateMetricDataStop
  };
}

export interface ReplaceMetricDataRefreshListAction extends Action {
  type: typeof ReplaceMetricDataRefreshList;
  ids: string[];
}

export function replaceMetricDataRefreshList(ids: string[]): ReplaceMetricDataRefreshListAction {
  return {
    type: ReplaceMetricDataRefreshList,
    ids
  };
}

export const isUpdateMetricsDataSucceededAction = isActionFactory<UpdateMetricsDataSucceededAction>(UpdateMetricsDataSucceeded);
